import { render, staticRenderFns } from "./XpSj.vue?vue&type=template&id=3803b75a&scoped=true&"
import script from "./XpSj.vue?vue&type=script&lang=js&"
export * from "./XpSj.vue?vue&type=script&lang=js&"
import style0 from "./XpSj.vue?vue&type=style&index=0&id=3803b75a&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803b75a",
  null
  
)

export default component.exports